<template>
	<ViewFeedItem class="view-feed-venuefeed">
		<template v-slot:header>
			<ViewLayoutModuleHeader v-bind:title="title" v-bind:subtitle="subtitle"></ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyMediaVenue
				animationStyle="none"
				type="table"
				v-bind:key="venueMediaCollection.requestTime"
				v-bind:limit="10"
				v-bind:venueMediaCollection="venueMediaCollection"
				v-on:select="Handle_OnSelectVenue"
			/>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Factory from '@/App/Factory';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, event, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedVenueFeed extends ViewBase {
		/**
		 * @return string
		 */
		protected get subtitle(): string {
			const formattedDate: string = ChalkySticks.Core.Utility.Format.formatTime(new Date(), 'MMMM D, YYYY');
			return `For ${formattedDate}`;
		}

		/**
		 * @return string
		 */
		protected get title(): string {
			return `Explore the world`;
		}

		/**
		 * @type ChalkySticks/Collection/VenueMedia
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.VenueMedia.collection({
					qp: {
						subgroup: 'table',
					},
				}),
		})
		public venueMediaCollection!: ChalkySticks.Collection.VenueMedia;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnClickRefresh(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.venueMediaCollection.setQueryParam('cb', Math.random().toString()).fetch();
		}

		/**
		 * @param ChalkySticks.Model.Media mediaModel
		 * @param number index
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(mediaModel: ChalkySticks.Model.Media, index: number): Promise<void> {
			const venueModel: ChalkySticks.Model.Venue = new ChalkySticks.Model.Venue(mediaModel.attributes.venue);

			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-venuefeed {
		.body {
			padding: 0 1rem 1rem 1rem;
		}
	}
</style>
